import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalSuccessUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content p-4" }
const _hoisted_4 = { class: "d-flex justify-content-end" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "content mx-auto" }
const _hoisted_8 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "my-4" }
const _hoisted_11 = { class: "bg-light py-3 ps-3 pe-2 mb-4" }
const _hoisted_12 = { class: "list-id" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = { class: "me-2" }
const _hoisted_15 = { class: "me-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "d-flex justify-content-center" }

import { ref, watchEffect } from 'vue'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Array,
  listUserFailed: Array,
},
  setup(__props) {

const props = __props

const listUser = ref<any[]>([])



watchEffect(() => {
  const { data, listUserFailed } = props
  listUser.value = data?.filter((item: any) => listUserFailed?.includes(item?.management_no))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('deleteList')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          (!__props.listUserFailed?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(translate)('CN10finishDel')), 1))
            : _createCommentVNode("", true),
          (__props.listUserFailed?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)('OE10updateFailed')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listUser.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "mb-2 d-flex align-items-center",
                        key: index
                      }, [
                        _createVNode(UserAliasIcon, {
                          userType: item?.user_type
                        }, null, 8, ["userType"]),
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item?.management_no), 1),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(item.family_name + ' ' + item.given_name), 1),
                        (item.status === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(translate)('SO10user30')), 1))
                          : _createCommentVNode("", true),
                        (item.status === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(translate)('OE12pause')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})